import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from "rxjs";
import {  EditUserRulesTemplateRequest } from "../../domain/requests/user-rules-template";
import { UserRulesTemplateRepository } from "../../repositories/user-rules-template.repository";
@Injectable({ providedIn: 'root' })
export class EditUserRulesTemplateUsecase implements UseCase<EditUserRulesTemplateRequest, string> {
  constructor(private readonly userRulesTemplateRepository: UserRulesTemplateRepository) {
  }

  execute(params: EditUserRulesTemplateRequest): Observable<string> {
    return this.userRulesTemplateRepository.EditUserRulesTemplate(params);
  }
}
